const ContactUsSchema = () => {
    var json_ld = {
        "@context": "https://schema.org/",
        "@type": "ContactPage",
        "description": "The webpage displays our main address shown on an interactive map. There's also a phone number shown and a form to get a callback",
        "name": "Contact Us Page",
        "potentialAction": "Callback Request, Address on a map, Phone Number",
        "url": `${process.env.NEXT_PUBLIC_HOME_URL}/contactus`,
    };

    const productJsonId = {
        __html: JSON.stringify(json_ld),
    };
    
    return (
        <script
            type="application/ld+json"
            dangerouslySetInnerHTML={productJsonId}
            id="product-jsonld"
            key="product-jsonld"
        />
    );
};

export default ContactUsSchema;
